<template>
  <v-footer
      class="footer"
      color="primary"
      height="auto"
  >
    <v-row align="center" class="footerContent" justify="center">
      <v-col cols="12" md="3">
        <v-row class="links" justify="center">
          <v-btn
              text
              to="/imprint"
          >
            {{ $t("IMPRINT_LINK") }}
          </v-btn>
          <v-btn
              text
              to="/privacy"
          >
            {{ $t("PRIVACY_LINK") }}
          </v-btn>
          <v-btn
              text
              to="/tos"
          >
            {{ $t("TERMS_CONDITIONS_SHORTNAME") }}
          </v-btn>
        </v-row>
      </v-col>
      <v-col class="paymentMethods" cols="12" md="6" sm="12">
        <div class="paymentText">
          <div v-if="paymentMethodActive('KLARNA_LATER')">
            <v-icon>check_circle_outline</v-icon>
            <span>{{ $t('FOOTER_PAY_PER_BILL') }}</span>
          </div>
          <div v-if="paymentMethodActive('BANK_TRANSFER')">
            <v-icon>check_circle_outline</v-icon>
            <span>{{ $t('FOOTER_PAY_PER_BANK_TRANSFER') }}</span>
          </div>
          <div v-if="paymentMethodActive('CASH_ENVELOPE')">
            <v-icon>check_circle_outline</v-icon>
            <span>{{ $t('FOOTER_PAY_PER_CASH_ENVELOPE') }}</span>
          </div>
        </div>
        <div class="icons">
          <img v-if="paymentMethodActive('SOFORT')" class="paymentIcon sofort" src="@/assets/payment/sofort.svg">
          <img v-if="paymentMethodActive('CREDIT_CARD')" class="paymentIcon visa" src="@/assets/payment/visa.svg">
          <img v-if="paymentMethodActive('CREDIT_CARD')" class="paymentIcon" src="@/assets/payment/mastercard.svg">
          <img v-if="paymentMethodActive('CREDIT_CARD')" class="paymentIcon" src="@/assets/payment/amex.svg">
          <v-icon v-if="paymentMethodActive('BANK_TRANSFER')" class="paymentIcon" size="30px">account_balance</v-icon>
          <v-icon v-if="paymentMethodActive('CASH_ENVELOPE')" class="paymentIcon" size="30px">mail</v-icon>
        </div>
      </v-col>
      <v-col
          class="footerSupport"
          cols="12"
          md="3"
          primary
          py-3 text-xs-center
          white--text
      >
        <div class="copyright" v-html="$t('FOOTER_COPYRIGHT_NOTICE')"></div>
        <HelpBubble/>
      </v-col>
    </v-row>
  </v-footer>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import HelpBubble from "@/components/HelpBubble.vue";

@Component({
  components: {HelpBubble}
})
export default class Footer extends BasicComponent {

}

</script>
<style lang="scss" scoped>
@use "../stylesheets/Variables.scss" as *;


.footer {
  padding: 10px;
  padding-top: 25px;

  .links {
    * {
      margin: 0;
    }
  }

  .paymentMethods {
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    border-radius: 5px;

    .icons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      .paymentIcon {
        display: inline-block;
        height: 30px;

        &.visa, &.sofort {
          height: 25px;
        }

        &:not(:first-of-type) {
          margin-left: 10px;
        }

        &:not(:last-of-type) {
          margin-right: 10px;
        }

        &.v-icon {
          margin-left: 10px;
        }
      }
    }

    .paymentText {
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      position: relative;

      *:not(:first-of-type) {
        padding-left: 15px;
      }

      *:not(:last-of-type) {
        padding-right: 15px;
      }

      div {
        display: flex;
        align-items: center;

        .v-icon {
          margin-right: 5px;
        }

      }
    }

    /*
    img {
      display: block;
      margin: 0 auto;
    }*/
  }
}

@media (max-width: 959px) {
  .footer {
    .footerContent {
      flex: 1 1 100%;
      min-width: 0;
      margin: 0;

      > .col-12 {
        min-width: 0;
      }
    }

    .links {
      margin: 0;

      .v-btn {
        max-width: 100%;
        height: auto;
        min-height: 36px;
        white-space: normal;

        ::v-deep .v-btn__content {
          flex: 1 1 auto;
          overflow-wrap: anywhere;
        }
      }
    }

    .paymentMethods .paymentText {
      flex-direction: column;
      gap: 8px;

      *:not(:first-of-type),
      *:not(:last-of-type) {
        padding: 0;
      }

      > div {
        max-width: 100%;
      }

      span {
        min-width: 0;
        overflow-wrap: anywhere;
      }
    }

    .footerSupport {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 12px;
      text-align: center;

      .copyright {
        min-width: 0;
        max-width: 100%;
        overflow-wrap: anywhere;
      }

      ::v-deep .bubbleContainer {
        margin-left: 0;
      }
    }
  }
}

</style>
<style lang="scss">

.copyright {
  display: inline-block;

  p {
    margin: 0 !important;
  }
}

</style>
